import {
  DocumentIcon,
  FileIcon,
  PinFilledIcon,
  PinIcon,
  StarFilledIcon,
  StarIcon,
} from '@sketchnote/icons';
import { MoreActionMenu } from '@sketchnote/shared-components';
import classNames from 'classnames';
import { Emoji } from 'emoji-mart';
import * as React from 'react';
import { useWorkspaceAccess } from 'src/components/workspaces/hooks/useWorkspaceAccess';

import { FileListProps } from '../routes/Files';

const { useCallback, useState, useEffect } = React;

export const FileGridItem = ({
  name,
  icon,
  modified,
  onClick,
  sharedWith,
  menuItems,
  onClickMenuItem,
  className,
  onPinFile,
  onFavoriteFile,
  pinned,
  favorite,
  type,
  view,
  id,
  primaryViewId,
  showMenu = true,
}: FileListProps): JSX.Element => {
  const [hoverGridItem, setHoverGridItem] = useState(false);
  const [pin, setPin] = useState(false);
  const [favoritefile, setFavoriteFile] = useState(false);
  const handleKeyEnter: React.KeyboardEventHandler<HTMLDivElement> = useCallback((e) => {
    if (e.key === 'Enter') {
      onClick?.({ fileId: id, viewId: primaryViewId, type: type, view: view });
    }
  }, []);

  const { isViewer } = useWorkspaceAccess();

  function handleOnClick() {
    onClick?.({ fileId: id, viewId: primaryViewId, type: type, view: view });
  }
  useEffect(() => {
    pinned && setPin(pinned);
  }, [pinned]);

  useEffect(() => {
    favorite && setFavoriteFile(favorite);
  }, [favorite]);

  function handleMoreMenuClick(item, e) {
    onClickMenuItem?.(item, e, id, name);
  }

  return (
    <div
      style={{ border: '1px solid #E2E4E9' }}
      className={classNames({
        'rounded-md relative hover:shadow-md transition-all duration-300 bg-white h-110 w-110  pt-12':
          true,
        [className || '']: !!className,
      })}
      tabIndex={0}
      title={`${name}`}
      role="button"
      onKeyDown={handleKeyEnter}
      onClick={handleOnClick}
      onMouseOver={() => setHoverGridItem(true)}
      onMouseLeave={() => setHoverGridItem(false)}
    >
      {hoverGridItem && (
        <div
          style={{ boxShadow: '0px 2px 8px rgba(19, 23, 32, 0.16)' }}
          className="absolute px-8 right-10 top-9 flex-end text-gray-500 flex bg-white rounded-md z-10"
        >
          <button
            className=""
            onClick={(e) => {
              e.stopPropagation();
              onFavoriteFile?.(id, !favoritefile, name || 'File');
              setFavoriteFile(!favoritefile);
            }}
          >
            {favoritefile ? (
              <StarFilledIcon className="mt-6 text-yellow-500" />
            ) : (
              <StarIcon className="text-gray-500" />
            )}
          </button>

          <button
            className="px-12"
            onClick={(e) => {
              e.stopPropagation();
              onPinFile?.(id, !pin, name || 'File');
              setPin(!pin);
            }}
          >
            {pin ? (
              <PinFilledIcon className="text-gray-500" />
            ) : (
              <PinIcon className="text-gray-500" />
            )}
          </button>
          {!isViewer && menuItems && showMenu && (
            <MoreActionMenu
              menuItems={menuItems}
              onClickMenuItem={handleMoreMenuClick as any}
              placement="bottom"
            />
          )}
        </div>
      )}

      <div className=" w-32 h-32  mx-auto">
        {icon?.id && icon?.type !== 'image' ? (
          <Emoji emoji={icon?.id} set="apple" size={32} />
        ) : icon?.id && icon?.type === 'image' ? (
          <img src={icon?.id} className="h-32 w-32" />
        ) : (
          <FileIcon className=" text-primary-300 rounded-sm block text-4xl" />
        )}
      </div>

      <div
        style={{ lineHeight: '120%' }}
        className={classNames({
          'title text-xs font-medium text-black-998 text-center mt-12 mb-12 w-82 mx-auto': true,
        })}
      >
        {name}
      </div>
    </div>
  );
};
